"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupedProduct = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _link = _interopRequireDefault(require("next/link"));
var _react = require("react");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const GroupedProduct = ({
  groupedProduct,
  isActive,
  getLinkHref,
  onProductClick
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    label,
    productCode
  } = groupedProduct;
  const shouldEnableClick = !isActive && onProductClick && !getLinkHref;
  const onClick = (0, _react.useCallback)(() => {
    onProductClick?.(productCode);
  }, [onProductClick, productCode]);
  const chipComponent = (0, _react.useMemo)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Chip, {
    "data-testid": getTestId(`${_constants.GROUPED_PRODUCT}-${productCode}`),
    label: label,
    variant: isActive ? 'filled' : 'outlined',
    size: "small",
    onClick: shouldEnableClick ? onClick : undefined
  }), [getTestId, productCode, label, isActive, shouldEnableClick, onClick]);
  if (!isActive && getLinkHref) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_link.default, {
      "data-testid": getTestId(`${_constants.GROUPED_PRODUCT_LINK}-${productCode}`),
      href: getLinkHref(productCode),
      children: chipComponent
    });
  }
  return chipComponent;
};
exports.GroupedProduct = GroupedProduct;
//# sourceMappingURL=GroupedProduct.js.map